<template>
  <div>
    <v-card v-for="i in 3" :key="`sk-main-${i}`" :class="{ 'mb-4': i < 3 }" outlined class="pa-4">
      <v-skeleton-loader
        type="subtitle"
        width="40%"
        class="mb-4 bg-transparent"
      ></v-skeleton-loader>
      <v-skeleton-loader class="mx-4" type="divider"></v-skeleton-loader>
      <v-skeleton-loader type="paragraph@2" class="bg-transparent"></v-skeleton-loader>
    </v-card>
  </div>
</template>
<script setup lang="ts"></script>
